/* eslint-disable react/jsx-key */
import React, { useEffect, useState } from "react";
import { TaskType, ImageSelectSingleStepTask, ImageSelectSingleStepAnswer } from "data-models/task-models";
import { QUESTION_ACTIONS, useFollowUp } from "providers/FollowUpProvider";
import { Tab, Tabs, Flex, Image, VStack, HStack, Center, TabList, TabPanel, TabPanels } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { TaskAdvice } from "./Common";
import CheckIcon from "common/CheckIcon";
import { apiBase } from "services/config";
import { TaskHeading } from "./Common/TaskHeading";
import { useFullscreen } from "providers/FullscreenProvider";

export default function ImageSelectSingleStepCmp() {
  const { t } = useTranslation();
  const { currentTask, dispatch } = useFollowUp();
  const task = currentTask as ImageSelectSingleStepTask;
  const [animatingId, setAnimatingId] = useState<ImageSelectSingleStepAnswer["id"] | null>(null);

  useEffect(() => {
    clearAnimation();
  }, []);

  const clearAnimation = () => {
    task.answerOptions.forEach(item => {
      const imageOptionsUnSelected = document.getElementsByClassName("image-unselected");
      Array.from(imageOptionsUnSelected).forEach(imageOption => {
        imageOption.classList.remove("image-unselected");
      });
      if (item.checked) {
        const imageOptionsSelected = document.getElementsByClassName("image-clicked");
        Array.from(imageOptionsSelected).forEach(imageOption => {
          imageOption.classList.remove("image-clicked");
        });
      }
    });
  };

  function onSelectedChange(changed: ImageSelectSingleStepAnswer["id"]) {
    const wasChecked = task.answerOptions.find(ao => ao.id === changed)?.checked;
    const newOptionsState = task.answerOptions.map(ao => ({
      ...ao,
      checked: ao.id === changed ? !ao.checked : ao.checked,
    }));
    if (!wasChecked) {
      setAnimatingId(changed);
      window.setTimeout(() => setAnimatingId(null), 300);
    } else {
      setAnimatingId(null);
    }
    dispatch({
      type: QUESTION_ACTIONS.UPDATE_ANSWERS,
      payload: newOptionsState,
    });
    dispatch({ type: QUESTION_ACTIONS.UNSKIP_CURRENT_TASK });
  }

  const onChangeTab = (index: number) => {
    dispatch({ type: QUESTION_ACTIONS.SET_CURRENT_STEP, payload: index });
  };

  return (
    <VStack pos="relative" h="full" w="full" p="5">
      <TaskHeading description={task.description} subtitle={task.subtitle} headingTitle={task?.title} />

      <Tabs h="full" w="full" pos="relative" variant="unstyled" onChange={onChangeTab} index={currentTask.step}>
        <TabList pb="4" pt="3">
          <Flex
            h="0"
            w="full"
            pos="absolute"
            alignSelf="center"
            justifySelf="center"
            borderTop="1px solid #2A0F74"
            zIndex={0}
          />
          <Tab
            px={4}
            py={2}
            mr={6}
            zIndex={1}
            border="1px solid #2A0F74"
            fontSize="xs"
            borderRadius="8px"
            bgColor="#6c40f6"
            _selected={{ bgColor: "#2A0F74", fontWeight: "700" }}
            _focus={{ boxShadow: "none" }}
          >
            <span style={{ opacity: 0.5, paddingRight: "10px" }}>{t("Step")} 1</span>
            {t("Explain_Scenario_Title")}
          </Tab>
        </TabList>

        <TabPanels h="full" w="full" py={0}>
          <TabPanel w="full" h="full" maxH="full">
            <HStack w="full" h="100%" minH={0} align="center" spacing="5" justify="center">
              {task.answerOptions.map(
                ao =>
                  ao.type === TaskType.ImageSelectSingleStep && (
                    <VStack key={ao.id} align="center" justify="center" h={{ base: "auto", lg: "50%" }} w="full">
                      <Center
                        w="full"
                        h="full"
                        pos="relative"
                        bgColor="white"
                        borderRadius="xl"
                        borderWidth="4px"
                        borderColor={ao.checked ? "pink.500" : "transparent"}
                        onClick={() => onSelectedChange(ao.id)}
                        className={[
                          "image",
                          ao.checked ? "image-clicked" : "image-unselected",
                          animatingId === ao.id && ao.checked ? "animate-in" : "",
                        ]
                          .filter(Boolean)
                          .join(" ")}
                        cursor="pointer"
                        role="button"
                        tabIndex={0}
                      >
                        <Center
                          pos="absolute"
                          left="1"
                          top="1"
                          boxSize="5"
                          bgColor={ao.checked ? "pink.500" : "lightgray"}
                          borderRadius="full"
                        >
                          <CheckIcon color="white" />
                        </Center>

                        <Image
                          src={apiBase + ao.imageUrl}
                          borderRadius="xl"
                          maxH="100%"
                          w="70%"
                          h="70%"
                          fit="contain"
                          maxW="70%"
                          alt=""
                        />
                      </Center>
                    </VStack>
                  ),
              )}
            </HStack>
          </TabPanel>
        </TabPanels>
      </Tabs>

      <TaskAdvice pb="0" pos="relative" minH="unset" bottom="-2" instructions={task.taskInstructions} />
    </VStack>
  );
}
